/*
 * Native Whey — secao sections/ep-native-whey.liquid
 *
 * O movimento principal e CSS puro (animation-timeline: view()), que roda fora da thread
 * principal. Este arquivo so cobre o que o CSS nao faz:
 *  1. navegador sem linha do tempo de rolagem -> .nw--io na raiz e .is-in em cada [data-nw]
 *     quando ele aparece (o que ja esta na tela entra marcado, sem piscar);
 *  2. contagem dos numeros ([data-nw-conta]) quando aparecem. O texto final e sempre o
 *     do HTML — so o numero conta, prefixo e sufixo ficam.
 * Com prefers-reduced-motion ou a secao em modo estatico, nada acontece.
 */
(() => {
  const reduzir = window.matchMedia('(prefers-reduced-motion: reduce)');
  const temLinhaDoTempo = !!(window.CSS && CSS.supports && CSS.supports('animation-timeline: view()'));

  function naTela(el) {
    const r = el.getBoundingClientRect();
    return r.bottom > 0 && r.top < window.innerHeight * 0.92 && r.width + r.height > 0;
  }

  function entradaSimples(raiz) {
    if (raiz.classList.contains('nw--io')) return;
    const els = raiz.querySelectorAll('[data-nw]');
    els.forEach((el) => { if (naTela(el)) el.classList.add('is-in'); });
    raiz.classList.add('nw--io');
    if (!('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('is-in'));
      return;
    }
    const io = new IntersectionObserver((entradas) => {
      for (const e of entradas) {
        if (!e.isIntersecting) continue;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      }
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    els.forEach((el) => { if (!el.classList.contains('is-in')) io.observe(el); });
  }

  const NUM = /(\d+(?:[.,]\d+)?)/g;
  function contar(el) {
    const final = el.textContent;
    const nums = final.match(NUM);
    if (!nums || nums.length !== 1) return;
    const bruto = nums[0];
    const sep = bruto.includes(',') ? ',' : '.';
    const casas = bruto.includes(sep) ? bruto.split(sep)[1].length : 0;
    const alvo = parseFloat(bruto.replace(',', '.'));
    const [antes, depois] = final.split(bruto);
    const dur = 1300;
    let t0 = null;
    el.style.minWidth = el.offsetWidth + 'px';
    function quadro(t) {
      if (t0 === null) t0 = t;
      const p = Math.min(1, (t - t0) / dur);
      const v = alvo * (1 - Math.pow(1 - p, 3));
      el.textContent = antes + v.toFixed(casas).replace('.', sep) + depois;
      if (p < 1) requestAnimationFrame(quadro);
      else { el.textContent = final; el.style.minWidth = ''; }
    }
    requestAnimationFrame(quadro);
  }

  function contadores(raiz) {
    const els = raiz.querySelectorAll('[data-nw-conta]:not([data-nw-contado])');
    if (!els.length || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entradas) => {
      for (const e of entradas) {
        if (!e.isIntersecting) continue;
        io.unobserve(e.target);
        e.target.setAttribute('data-nw-contado', '');
        contar(e.target);
      }
    }, { threshold: 0.6 });
    els.forEach((el) => io.observe(el));
  }

  function iniciar(escopo) {
    if (reduzir.matches) return;
    escopo.querySelectorAll('[data-nw-raiz]').forEach((raiz) => {
      if (raiz.classList.contains('nw--estatico')) return;
      if (!temLinhaDoTempo) entradaSimples(raiz);
      contadores(raiz);
    });
  }

  iniciar(document);
  // editor de temas: a secao e re-renderizada a cada ajuste
  document.addEventListener('shopify:section:load', (e) => iniciar(e.target));
})();
